import { render, staticRenderFns } from "./section-products-carousel.vue?vue&type=template&id=8b67237c&scoped=true&"
import script from "./section-products-carousel.vue?vue&type=script&lang=js&"
export * from "./section-products-carousel.vue?vue&type=script&lang=js&"
import style0 from "./section-products-carousel.vue?vue&type=style&index=0&id=8b67237c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b67237c",
  null
  
)

export default component.exports